import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import type { FilterItem } from 'widgets/FilterEditor/model'

import {
  isCampaignStatusWidget,
  WidgetCampaignStatus,
} from 'widgets/FilterEditor/ui/Widget/WidgetCampaignStatus'
import {
  WidgetPowerDialerStatus,
  isPowerDialerStatusWidget,
} from 'widgets/FilterEditor/ui/Widget/WidgetPowerDialerStatus'
import { WidgetLocal, isWidgetLocal } from 'widgets/FilterEditor/ui/Widget/WidgetLocal'
import {
  WidgetAutomationLogResultStatus,
  isAutomationLogResultStatusWidget,
} from 'widgets/FilterEditor/ui/Widget/WidgetAutomationLogResultStatus'
import { WidgetContacts, isContactWidget } from './WidgetContacts'
import { WidgetDate, isDateWidget } from './WidgetDate'
import { WidgetDateText, isDateTextWidget } from './WidgetDateText'
import { WidgetEmpty, isEmptyWidget } from './WidgetEmpty'
import { WidgetMultiText, isMultiTextWidget } from './WidgetMultiText'
import { WidgetHubspot, isHubspotWidget } from './WidgetHubspot'
import { WidgetMultiSelect, isMultiSelectWidget } from './WidgetMultiSelect'
import { WidgetAsyncTags, isAsyncTagsWidget } from './WidgetAsyncTags'
import { WidgetBroadcastStatus, isBroadcastStatusWidget } from './WidgetBroadcastStatus'
import { WidgetMultiUsers, isMultiUsersWidget } from './WidgetMultiUsers'
import { WidgetMultiInboxes, isMultiInboxesWidget } from './WidgetMultiInboxes'
import { WidgetMultiRecurringType, isMultiRecurringTypeWidget } from './WidgetMultiRecurringType'
import { WidgetTriggerStatus, isTriggerStatusWidget } from './WidgetTriggerStatus'
import { WidgetIntegration, isIntegrationWidget } from './WidgetIntegration'
import {
  isAutomationLogExecutionStatusWidget,
  WidgetAutomationLogExecutionStatus,
} from './WidgetAutomationLogExecutionStatus'

export const getWidgetType = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) => {
  switch (true) {
    case isEmptyWidget<T, C>(filterItem):
      return 'empty'
    case isMultiRecurringTypeWidget<T, C>(filterItem):
      return 'multi_recurring_type'
    case isMultiInboxesWidget<T, C>(filterItem):
      return 'multi_inboxes'
    case isMultiUsersWidget<T, C>(filterItem):
      return 'multi_users'
    case isBroadcastStatusWidget<T, C>(filterItem):
      return 'broadcast_status'
    case isTriggerStatusWidget<T, C>(filterItem):
      return 'trigger_status'
    case isCampaignStatusWidget<T, C>(filterItem):
      return 'campaign_status'
    case isAutomationLogExecutionStatusWidget<T, C>(filterItem):
      return 'automation_log_execution_status'
    case isAutomationLogResultStatusWidget<T, C>(filterItem):
      return 'automation_log_result_status'
    case isPowerDialerStatusWidget<T, C>(filterItem):
      return 'power_dialer_status'
    case isIntegrationWidget<T, C>(filterItem):
      return 'integration'
    case isDateTextWidget<T, C>(filterItem):
      return 'date_text'
    case isMultiSelectWidget<T, C>(filterItem):
      return 'multi_select'
    case isMultiTextWidget<T, C>(filterItem):
      return 'multi_text'
    case isAsyncTagsWidget<T, C>(filterItem):
      return 'tags'
    case isDateWidget<T, C>(filterItem):
      return 'date'
    case isHubspotWidget<T, C>(filterItem):
      return 'hubspot'
    case isWidgetLocal<T, C>(filterItem):
      return 'broadcast'
    case isContactWidget<T, C>(filterItem):
      return 'contact'

    default:
      return 'empty'
  }
}

export const getWidgetComponent = (filterItem: FilterItem) => {
  switch (getWidgetType(filterItem)) {
    case 'multi_recurring_type':
      return WidgetMultiRecurringType
    case 'multi_inboxes':
      return WidgetMultiInboxes
    case 'multi_users':
      return WidgetMultiUsers
    case 'broadcast_status':
      return WidgetBroadcastStatus
    case 'trigger_status':
      return WidgetTriggerStatus
    case 'integration':
      return WidgetIntegration
    case 'empty':
      return WidgetEmpty
    case 'date_text':
      return WidgetDateText
    case 'multi_select':
      return WidgetMultiSelect
    case 'multi_text':
      return WidgetMultiText
    case 'tags':
      return WidgetAsyncTags
    case 'date':
      return WidgetDate
    case 'hubspot':
      return WidgetHubspot
    case 'campaign_status':
      return WidgetCampaignStatus
    case 'power_dialer_status':
      return WidgetPowerDialerStatus
    case 'automation_log_execution_status':
      return WidgetAutomationLogExecutionStatus
    case 'automation_log_result_status':
      return WidgetAutomationLogResultStatus
    case 'broadcast':
      return WidgetLocal
    case 'contact':
      return WidgetContacts
    default:
      return WidgetEmpty
  }
}
